module.exports = __webpack_public_path__ + "img/2-3.5c9fa967.png";